import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to critical origins BEFORE anything else
const origins = ['https://cdn.magicpatterns.com', 'https://images.unsplash.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
origins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (href.includes('gstatic')) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preload hero image (LCP) — discoverable from initial document
const preload = document.createElement('link');
preload.rel = 'preload';
preload.as = 'image';
preload.href = 'https://cdn.magicpatterns.com/uploads/jjgrz3YfbYyDMDr3zThu24/6_TOMOS_COMPLETOS_(1).png';
preload.setAttribute('fetchpriority', 'high');
document.head.appendChild(preload);
// Load Google Fonts NON-BLOCKING (avoids render-blocking @import)
const fontLink = document.createElement('link');
fontLink.rel = 'stylesheet';
fontLink.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap';
fontLink.media = 'print';
fontLink.onload = function () {
  ;
  (this as HTMLLinkElement).media = 'all';
};
document.head.appendChild(fontLink);
// Fallback for noscript
const noscriptStyle = document.createElement('noscript');
noscriptStyle.innerHTML = '<link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap">';
document.head.appendChild(noscriptStyle);
render(<App data-id="element-3" />, document.getElementById('root'));